import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

interface FooterButton {
  text: string
  variant: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info'
  outlined?: boolean
  onClick: () => void
  testid: string
}

interface ModalProps {
  show: boolean
  onHide: () => void
  title: string
  showClose: boolean
  showFooter: boolean
  children: React.ReactNode
  footerButtons?: FooterButton[]
  showMessage?: boolean
  messageText?: string
  isLoading?: boolean
  loadingText?: string
  customHeaderTitleClass?: string
}

const CustomModal = (props: ModalProps): JSX.Element => {
  const renderFooter = () => {
    if (!props.showFooter || !props.footerButtons) return null

    return (
      <React.Fragment>
        <Modal.Footer>
          {props.footerButtons.map((button: FooterButton, index: number) => {
            const btnVariant =
              button.outlined === undefined || button.outlined === true
                ? `outline-${button.variant}`
                : button.variant

            return (
              <Button
                key={index}
                variant={btnVariant}
                onClick={button.onClick}
                name={`button-${index}`}
                className='footer-button'
                data-testid={button.testid}
              >
                {button.text}
              </Button>
            )
          })}
        </Modal.Footer>
      </React.Fragment>
    )
  }

  const renderMessage = (): JSX.Element => {
    return (
      <Modal.Header closeButton={false} className='custom-header'>
        <div className='header-message'>
          <div className='mdi mdi-alert-rhombus mr-2' />
          <div>{props.messageText ?? ''}</div>
        </div>
      </Modal.Header>
    )
  }

  const renderLoader = (): JSX.Element => {
    return (
      <div className='loading-spinner__box'>
        <div className='loading-spinner'>
          <div />
          <div />
          <div />
        </div>
        <span className='loading-spinner__text'>
          {props.loadingText ? props.loadingText : 'Loading...'}
        </span>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop='static'
        className={'' + (props.isLoading ? 'overlay' : '')}
      >
        {props.showMessage === true ? renderMessage() : null}
        {props.isLoading ? renderLoader() : null}
        <Modal.Header closeButton={props.showClose}>
          {props.customHeaderTitleClass ? (
            <Modal.Title className={`${props.customHeaderTitleClass}`}>
              {props.title}
            </Modal.Title>
          ) : (
            <Modal.Title className='custom-title'>{props.title}</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body className='custom-modal-body'>{props.children}</Modal.Body>
        {renderFooter()}
      </Modal>
    </React.Fragment>
  )
}

export default CustomModal
